/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import fixTableCellWidth from "../../../utils/fixTableCellWidth";

function createData(id, name, company_name, type_name) {
  return {
    id,
    name,
    company_name,
    type_name,
  };
}

function Row(props) {
  const { row } = props;

  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
        <TableCell className="tablecell" align="left" title={row.name}
                   style={fixTableCellWidth("160px")}>{row.name}</TableCell>
        <TableCell className="tablecell" align="left" title={row.company_name}
                   style={fixTableCellWidth("160px")}>{row.company_name}</TableCell>
        <TableCell className="tablecell" align="left" title={row.type_name}
                   style={fixTableCellWidth("160px")}>{row.type_name}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function Opportunities({ singleGhollak }) {
  const rows = singleGhollak?.opportunities?.map(item => createData(item.id, item.name, item?.company?.name, item.type_name,
  ));
  return (
    <>
      {singleGhollak?.opportunities.length === 0 ? <p style={{ fontSize: 16 }}>فرصتی ثبت نشده است!</p> :
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ padding: 0 }}>
              <TableRow>
                <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
                <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام شرکت</TableCell>
                <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نوع</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ display: "block" }}>
              {rows.map((row) => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>}
    </>
  );
}
